var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtilAdminSettingsMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4073 4.97596C12.3967 4.41947 13.6046 4.41947 14.594 4.97596L20.0107 8.0228C21.034 8.59844 21.6673 9.68129 21.6673 10.8554V16.8039C21.6673 17.978 21.034 19.0609 20.0107 19.6365L14.5939 22.6834C13.6046 23.2399 12.3967 23.2399 11.4074 22.6834L5.99074 19.6368C4.96733 19.0613 4.33398 17.9784 4.33398 16.8041V10.8554C4.33398 9.68127 4.96729 8.59841 5.99066 8.02278L11.4073 4.97596Z",
    stroke: "#171717",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13.8281C16.25 15.623 14.7949 17.0781 13 17.0781C11.2051 17.0781 9.75 15.623 9.75 13.8281C9.75 12.0332 11.2051 10.5781 13 10.5781C14.7949 10.5781 16.25 12.0332 16.25 13.8281Z",
    stroke: "#171717",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilAdminSettingsMenuIcon);
export default __webpack_public_path__ + "static/media/util-admin-settings-menu-icon.de1f73c6307c476e7de45f1190864c02.svg";
export { ForwardRef as ReactComponent };